import { Component, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { SiteService } from 'src/app/services/site.service';
import { IconsComponent } from '../icons/icons.component';
import { PagesSlugsService } from './pages-slugs.service';

@Component({
  selector: 'app-pages-slugs',
  templateUrl: './pages-slugs.component.html',
  styleUrls: ['./pages-slugs.component.css']
})
export class PagesSlugsComponent implements OnInit {

  constructor(
    public slugsService: PagesSlugsService,
    public siteService: SiteService,
    public dialogRef: MatDialogRef<IconsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const userData = localStorage.getItem('userData');
    const currentCulture = userData ? JSON.parse(userData).Culture : '0';
    const siteId = userData ? JSON.parse(userData).DefaultSiteInfo.siteId : 0;

    this.siteService.getUsedSiteCultures(2)
      .pipe(
        tap((cultures) => {
          if (cultures && cultures.length) {
            const initialCulture = this.data.cultureId ? cultures.find(el => el.id == this.data.cultureId) : null
            this.selectedCulture.setValue(initialCulture ? initialCulture['id'] : cultures[0].id);
            this.selectedCulture.updateValueAndValidity();
          }
        })
      )
      .subscribe()
  }

  pagesSlugs$: Observable<any[]>;
  selectedCategoryValue;
  selectedProductValue;
  selectedCulture = new FormControl(null);
  selectedCategory = new FormControl(1);
  selectedCategoryForProduct = new FormControl(1)
  filterText = new FormControl('');

  ngOnInit() {

    this.slugsService.resetSubjects();

    this.pagesSlugs$ = this.slugsService.pagesSlugs$

    this.filterText.valueChanges
      .subscribe(
        value => {
          console.log(value)
        }
      )

    this.selectedCulture.valueChanges
      .pipe(
        tap(() => this.slugsService.resetSubjects()),
        distinctUntilChanged(),
        switchMap(v => {
          if (this.data.source == 'page') {
            return this.slugsService.getAllPagesFlat(2, this.selectedCulture.value)
          }
          else if (this.data.source == 'post') {
            return this.GetCategoriesbySiteId()
          }
          else if (this.data.source == 'category' || this.data.source == 'product') {
            return this.GetAllCategories()
          }
          else if (this.data.source == 'brand') {
            return this.getAllBrand()
          }

        })
      )
      .subscribe();

    this.selectedCategory.valueChanges
      .pipe(
        //distinctUntilChanged(),
        switchMap(v => {
          return this.slugsService.getPostsByCategory({
            categoriesIds: [v],
            pageNo: 0,
            pageSize: 10000,
            postsSort: '',
            searchValue: this.filterText.value
          } ,Number(this.selectedCulture.value) )
        })
      )
      .subscribe();


    this.selectedCategoryForProduct.valueChanges.pipe(
      switchMap(v => {

        return this.slugsService.GetAllProductsFlats(<number>this.selectedCulture.value, <number>this.selectedCategoryForProduct.value)
      })
    ).subscribe();

  }




  getCategoriesDetails() {

  }

  selectPage(page) {
    console.log('select page', page)
    if (this.data.source == 'category' || this.data.source == 'brand' || this.data.source == 'product') {
      return this.dialogRef.close({ slugTargetId: this.data.source == 'category' ? page.categoryId : page.id, slug: page.slug })
    }

    if (this.data.source == 'page') {
      return this.dialogRef.close({


        slugTargetId: page.pageId,
        slug: page.parentPageSlug,
        parentId: page.parentPageId,
        name: page.name
      })
    } else if (this.data.source == 'post') {

      if (page.postCultures && page.postCultures.length) {
        page = page.postCultures.filter(element => {
          if (element.culture.id == this.selectedCulture.value) {
            return element;
          }
        })
        page = page[0]
      }
      return this.dialogRef.close({ slugTargetId: page.id, slug: page.slug })
    }
    else {
      this.dialogRef.close({ slugTargetId: page.id, slug: page.title })
    }

  }

  close() {
    this.dialogRef.close(null);
  }
  getProduct(id: number) {
    return this.slugsService.getProductById(id).subscribe(res => {
      this.selectedProductValue = res
    })
  }
  getAllBrand() {
    return this.slugsService.getAllBrands(<number>this.selectedCulture.value)
  }
  GetCategoriesbySiteId() {
    let params2 = {
      name: "",
      cultureId: (<number>this.selectedCulture.value),
      categoryTypedId: [7]
      ,
      pagination: {
        pageSize: 1000,
        pageNumber: 0,
      },
    };

    let params = {
      pagination: { start: 0, number: 1000 },
      search: {
        predicateObject: {
          'CultureId': (<number>this.selectedCulture.value).toString(),
          'CategoryTypeId': '7'
        }
      },
      Sort: {}
    }

    return this.slugsService.getPostsCategories(7, <number>this.selectedCulture.value)
  }

  getPostNameUpToCulture(postCultures) {

    let name
    for (let i = 0; i < postCultures.length; i++) {
      if (postCultures[i].culture && postCultures[i].culture.id ===  Number(this.selectedCulture.value)) {
        name = postCultures[i]; break;

      }
    }
    return name ? name.slug : '';
  }
  GetAllCategories() {
    let params2 = {
      name: "",
      cultureId: (<number>this.selectedCulture.value),
      categoryTypedId: [2]
      ,
      pagination: {
        pageSize: 1000,
        pageNumber: 0,
      },
    };
    let params = {
      pagination: { start: 0, number: 10000 },
      search: {
        predicateObject: {
          'CultureId': (<number>this.selectedCulture.value).toString(),
          'CategoryTypeId': '2'
        }
      },
      Sort: {}
    }

    return this.slugsService.getPostsCategories(2, <number>this.selectedCulture.value)
  }
  // GetAllProducts(){
  //   return this.slugsService.GetAllProductsFlats(<number>this.selectedCulture.value)
  // }
  selectCat(id) {
    return this.slugsService.getCategoryById(id).subscribe(res => {
      this.selectedCategoryValue = res
    })
  }
  // FilterPages() {
  //   let pages;
  //   if (this.filterText != "") {
  //     this.allPages.forEach((element) => {
  //       if (
  //         element.name.toUpperCase().indexOf(this.filterText.toUpperCase()) >= 0
  //       ) {
  //         this.pages.push(element);
  //       }
  //     });
  //   } else {
  //     this.pages = this.allPages;
  //   }
  // }
}

@Pipe({
  name: 'filterPageSlugs'
})
export class FilterPageSlugsPipe implements PipeTransform {

  transform(value: any[], key?: string) {

    if (!key) { return value; }

    return value.filter(x => x.name.toLowerCase().includes(key.toLowerCase()))
  }

}
